import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import createStore from './lib/createStore';
import getConfigurator from './lib/getConfigurator';
import { productConfigurator } from './lib/configSingleton';
import "bootstrap/dist/css/bootstrap.min.css"; 

const store = createStore();
const root = createRoot(document.querySelector('#configurator-root'));

root.render(
  <Provider store={store}>
    {getConfigurator(productConfigurator.product)}
  </Provider>
);